<template>
  <div class="nissan-layout" v-if="type === LoginType.WECHAT">
    <div class="nissan-layout-content">
      <WechatLogin v-if="ixWX" :isCheckAgreement="isCheckAgreement" />
      <div class="phone-login">
        <img
          src="./images/btn-phone.png"
          class="img-btn-phone"
          @click="toPhoneLogin"
        />
      </div>
      <Agreement class="nissan-aggrement" v-model="isCheckAgreement" />
    </div>
  </div>
  <PhoneLogin v-else-if="type === LoginType.PHONE" @back="toIndex" />
</template>

<script>
import PhoneLogin from './phone.vue'
import WechatLogin from './wechat.vue'
import { LoginType } from './enum'
import { isWechat } from '@/utils/index'
import Agreement from '@/components/login/Agreement'

export default {
  components: {
    PhoneLogin,
    WechatLogin,
    Agreement,
  },
  created() {
    this.init()
  },

  data() {
    return {
      type: '',
      LoginType,
      isCheckAgreement: false,
    }
  },
  methods: {
    init() {
      this.ixWX ? this.toIndex() : this.toPhoneLogin()
    },
    toPhoneLogin() {
      this.type = LoginType.PHONE
    },
    toIndex() {
      this.type = LoginType.WECHAT
    },
  },
  computed: {
    ixWX() {
      return isWechat()
    },
  },
}
</script>
<style lang="scss">
.nissan-layout {
  background-image: url('./images/nissan-bg.png');
  background-size: 100% auto;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;

  .nissan-aggrement {
    margin-top: 12px;
  }

  .nissan-layout-content {
    padding: 0 44px;
    position: absolute;
    bottom: 50px;
  }

  .phone-login {
    width: 100%;
    margin-top: 6px;

    .img-btn-phone {
      width: 100%;
    }
  }
}
</style>
